import axios from 'axios';
import { getCookie } from '@/utils/cookies';

export function createCoreServices() {
  return {
    baseUrl() { return `${process.env.VUE_APP_BASE_URL}/api`; },
    createUrl(url) {
      if (url.startsWith('http')) return url;
      return `${this.baseUrl()}${url}`;
    },
    async get(url) {
      return axios.get(this.createUrl(url), { headers: this.getRequestHeader() });
    },
    async downloadBlob(url, data) {
      return axios.post(this.createUrl(url), data, { headers: this.getRequestHeader(), responseType: 'blob' });
    },
    async downloadGetBlob(url) {
      return axios.get(this.createUrl(url), { headers: this.getRequestHeader(), responseType: 'blob' });
    },
    async post(url, data, headers) {
      if (!headers) headers = this.getRequestHeader();
      return axios.post(this.createUrl(url), data, { headers: headers });
    },
    async put(url, data) {
      return axios.put(this.createUrl(url), data, { headers: this.getRequestHeader() });
    },
    async patch(url, data) {
      return axios.patch(this.createUrl(url), data, { headers: this.getRequestHeader() });
    },
    async delete(url, data) {
      return axios.delete(this.createUrl(url), { headers: this.getRequestHeader(), data: data });
    },
    getRequestHeader() {
      const accessToken = getCookie('accessToken');
      const headers = { 'Content-Type': 'application/json' };
      if (accessToken) headers['Authorization'] =  `Bearer ${accessToken}`;
      return headers;
    },
    getMultipartRequestHeader() {
      const headers = this.getRequestHeader();
      headers['Content-Type'] = 'multipart/form-data';
      return headers;
    },
  };
}
